module.exports = __webpack_public_path__ + "img/avatar-60.8c3ea2bb.png";